module.exports = __webpack_public_path__ + "static/media/aljibesCamila.27f76787.mp3";